import { z } from "zod";

/**
 * CPF do cliente pessoa física: mesma regra de Services/Cpf.cs no backend. 11 dígitos, com ou sem máscara (pontos,
 * hífen e espaços), não todos iguais e com os dois dígitos verificadores (módulo 11) corretos.
 * Nunca coloque o CPF completo em URL, query key, console, toast, título de página ou analytics.
 */

export const CPF_LENGTH = 11;

/** Só os dígitos. */
export const normalizeCpf = (value?: string | null): string => (value ?? "").replace(/\D/g, "");

const checkDigit = (digits: string, length: number): number => {
  let sum = 0;
  for (let i = 0; i < length; i++) sum += Number(digits[i]) * (length + 1 - i);
  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
};

export const isValidCpf = (value?: string | null): boolean => {
  if (!value || !value.trim() || /[^\d.\- ]/.test(value)) return false;
  const digits = normalizeCpf(value);
  if (digits.length !== CPF_LENGTH || /^(\d)\1{10}$/.test(digits)) return false;
  return checkDigit(digits, 9) === Number(digits[9]) && checkDigit(digits, 10) === Number(digits[10]);
};

export const CPF_INVALID_MESSAGE = "CPF inválido.";

/** Campo de CPF do formulário: aceita o valor com a máscara de digitação; normalize antes de enviar. */
export const cpfSchema = z.string().trim().min(1, "Informe o CPF.").refine(isValidCpf, CPF_INVALID_MESSAGE);
